export default __webpack_public_path__ + "static/media/card-composition.fe193a4c.svg";